import React, { useCallback, useEffect, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { WorkShiftDialog } from "./WorkShiftDialog";
import {
    PlannedWorkShiftDto,
    PlannedWorkShiftSaveDto,
} from "../../models/plannedWorkShift/plannedWorkShift";
import {
    WorkShiftDialogParams,
    WorkShiftPlanningTab,
} from "./WorkShiftPlanningRouter";
import { Base } from "../../framework/base";
import { getPlannedWorkShift } from "../../services/plannedWorkShiftService";
import { showApiError } from "../framework/formUtils";
import { RecurrenceAction } from "../../models/common/enums";

export const WorkShiftDialogWrapper = () => {
    const history = useHistory();
    const location = useLocation();
    const state = location.state as { shift?: PlannedWorkShiftDto } | undefined;
    const [shift, setShift] = useState<PlannedWorkShiftSaveDto>();
    const { id, date, targetId, tab, recurrenceAction } =
        useParams<WorkShiftDialogParams>();

    const initShift = useCallback(
        ({
            id,
            rowId,
            employeeId,
            vehicleId,
            routeId,
            startTime,
            endTime,
            label,
            comment,
            recurrence,
            isTempInstance,
            isGeneratedFromRecurrence,
            isOverridenFromRecurrence,
        }: PlannedWorkShiftDto) => {
            const recurrenceVal = !!recurrence ? { ...recurrence } : recurrence;

            // If editing part of the series set recurrence start to the correct date.
            if (
                !!recurrenceVal &&
                recurrenceAction === RecurrenceAction.AllFuture
            ) {
                recurrenceVal.recurrenceStartDate =
                    Base.dayjsToJsonDate(startTime);
            }

            setShift({
                id,
                rowId,
                employeeId,
                vehicleId,
                routeId,
                startTime,
                endTime,
                label,
                comment,
                recurrence: recurrenceVal,
                isTempInstance,
                isGeneratedFromRecurrence,
                isOverridenFromRecurrence,
            });
        },
        [setShift, recurrenceAction]
    );

    useEffect(() => {
        if (state?.shift) {
            initShift(state.shift);
        } else if (id) {
            getPlannedWorkShift(id)
                .then(initShift)
                .catch(showApiError);
        } else {
            const startTime = Base.dayjsToJsonDateTime(
                Base.dateSet(date, "hours", 8).set("minutes", 0)
            );
            const endTime = Base.dayjsToJsonDateTime(
                Base.dateSet(date, "hours", 16).set("minutes", 0)
            );
            setShift({
                id: null,
                rowId: null,
                employeeId: tab === WorkShiftPlanningTab.Employee && !!targetId ? targetId : null,
                vehicleId: tab === WorkShiftPlanningTab.Vehicle && !!targetId ? targetId : null,
                routeId: tab === WorkShiftPlanningTab.Route && !!targetId ? targetId : null,
                startTime,
                endTime,
                label: null,
                comment: null,
            });
        }
    }, [date, id, targetId, tab, state]);

    return (
        <WorkShiftDialog
            isEdit={!!id}
            open
            item={shift}
            onClose={() => history.goBack()}
            recurrenceAction={recurrenceAction}
        />
    );
};